import React from "react";

interface Props {
    additionalClassName?: string;
}

export const InputFormBlock: React.FC<React.PropsWithChildren<Props>> = props => {
    const { children, additionalClassName } = props;
    return (
        <div
            className={`p-1 md:p-4 lg:shadow rounded ring-gray-300 lg:ring-1 bg-white ${
                additionalClassName ?? ""
            }`}>
            {children}
        </div>
    );
};
